module.exports = __webpack_public_path__ + "img/20171229_1727361.cfbaea2f.jpg";